import { Divider, Skeleton } from 'antd';
import classNames from 'classnames/bind';
import { useNavigate } from 'react-router';
import notificationAPI from '~/api/NotificationAPI';
import Loading from '../common/Loading';
import NoData from '../common/NoData';
import styles from './Notification.module.scss';
import NotificationItem from './NotificationItem';
import InfiniteScroll from 'react-infinite-scroll-component';
import config from '~/config';

const cx = classNames.bind(styles);
function Notification({ notiList = [], setNotiList, loading = true, fetchNotiList, countNoti }) {
    const navigate = useNavigate();
    const seenNoti = async (notiId) => {
        try {
            await notificationAPI.update(notiId, {
                seen: true,
            });

            fetchNotiList();
        } catch (err) {
            console.log(err);
        }
    };

    const handleNavigate = (noti) => {
        seenNoti(noti.id);
        if (noti.order_id) {
            navigate(`/don-hang/${noti.order_id}`);
        } else if (noti.booking_id) {
            navigate(`/lich-dat/${noti.booking_id}`);
        } else if (noti.post_id) {
            navigate(`/bai-viet/${noti.post_id}`);
        } else if (noti.action === 'MEMBER_WILL_REMOVE') {
            navigate(config.routes.downLineCollab);
        } else if (noti.action === 'RESET_WALLET') {
            if (window.innerWidth > 480) {
                navigate(config.routes.withdraw);
            } else {
                navigate(config.routes.personalPage);
            }
        } else if (noti.action === 'APPROVED' || noti.action === 'APPROVED_REQUEST_DEPOSIT_FOR_FIRST_TIME') {
            navigate(config.routes.historyTopUp);
        } else {
            navigate(`/chi-tiet-thong-bao/${noti.id}`);
        }
    };

    return (
        <div className={cx('wrapper')} id="notiList">
            {notiList.length === 0 ? (
                <NoData text={'No new notifications'} />
            ) : (
                <div className={cx('noti__list')}>
                    <InfiniteScroll
                        dataLength={notiList.length}
                        next={() => fetchNotiList(25)}
                        hasMore={notiList.length < countNoti}
                        style={{
                            overflowX: 'hidden',
                        }}
                        loader={
                            <Skeleton
                                style={{
                                    padding: '20px',
                                }}
                                avatar
                                paragraph={{
                                    rows: 1,
                                }}
                                active
                            />
                        }
                        endMessage={<Divider plain>Notification is over 🤐</Divider>}
                        scrollableTarget="notiList"
                    >
                        {notiList.map((noti) => (
                            <NotificationItem key={noti.id} noti={noti} onClick={() => handleNavigate(noti)} />
                        ))}
                    </InfiniteScroll>
                </div>
            )}
        </div>
    );
}

export default Notification;
